<template>
  <div class="base-dialog" v-if="isShow">
    <div class="dialog-main">
      <div class="dialog-cn category-cn" v-if="isType === 'addAttrSwitch'">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="category-ipt dialog-v">
          <div>
            <span style="width: 100px">属性名：</span>
            <el-input v-model="content" placeholder="请输入" ref="switchInputRef" clearable></el-input>
          </div>
          <div style="margin: 20px 0">
            <span style="width: 100px">是否前端展示：</span>
            <el-switch v-model="isSwitchShow" active-color="#1473E6" inactive-color="#8c8c8c" active-value="1" inactive-value="0">
            </el-switch>
          </div>
        </div>
        <div class="dialog-btn">
          <el-button @click="checkAttrRepeat" round type="primary">确定</el-button>
        </div>
      </div>
      <!--      选择尺寸-->
      <div class="dialog-cn" v-if="isType === 'selectComposeSize'" style="width: 750px">
        <i class="el-icon-circle-close" @click="hide"></i>
        <p>{{ title }}</p>
        <div class="compose-cn dialog-v">
          <div class="check">
            <div>
              <span>关键词：</span>
              <el-input v-model="composeKeyword" clearable></el-input>
            </div>
            <el-button round>查询</el-button>
          </div>
          <el-table :data="technologyList" border style="max-height: 400px;overflow-y: scroll" :empty-text="'暂无数据'">
            <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
            <el-table-column label="尺寸类型" prop="composeName">
            </el-table-column>
            <el-table-column label="规格" prop="">
              <template v-slot="scope"> 宽度:{{ scope.row.sizeWidth }}mm 高度:{{ scope.row.sizeHeight }}mm </template>
            </el-table-column>
            <el-table-column label="出血类型">
              <template v-slot="scope"> {{ scope.row.bleed.bleedName }} </template>
            </el-table-column>
            <el-table-column label="出血" prop="">
              <template v-slot="scope"> 上方:{{ scope.row.bleed.bleedTop }}mm 下方:{{ scope.row.bleed.bleedBottom }}mm 内侧:{{ scope.row.bleed.bleedIn }}mm 外侧:{{ scope.row.bleed.bleedOut }}mm </template>
            </el-table-column>
            <el-table-column label="操作">
              <template v-slot="scope">
                <span class="color-blue" @click="selectComposeSize(scope.row)">选择</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $axios from 'axios'
import { dictUsable, dictAdd, sizeList, bleedDetail } from '@/api/pms'
export default {
  data () {
    return {
      isShow: false,
      title: '',
      content: '',
      isSwitchShow: 0,
      technologyList: [],
      composeKeyword: '',
      submitType: '',
      selectComposeSizeList: []
    }
  },
  methods: {
    show (type, title, content, list, index, labelTitle) {
      this.isShow = true
      // 类型
      this.isType = type
      // 标题
      this.title = title
      this.content = content
      if (type === 'selectComposeSize') {
        this.technologyList = []
        this.getComposeTypeSize()
      }
      this.submitType = labelTitle
    },
    hide () {
      this.isShow = false
    },
    // 属性名查重
    checkAttrRepeat () {
      let name = {
        name: this.content
      }
      if (this.content === '') {
        this.$message.error('属性名称不能为空')
        this.$refs.switchInputRef.focus()
        return false
      }
      dictUsable({ name: this.$qs.stringify(name) }).then((res) => {
        if (res.data.code === -1) {
          this.$message({
            type: 'error',
            message: '属性名重复'
          })
          this.$refs.iptRef.focus()
        } else if (res.data.success) {
          this.addAttrSwitch()
          this.$emit('addAttr')
        } else {
        }
      })
    },
    addAttrSwitch () {
      dictAdd({
        pid: 0,
        propKey: this.content,
        propUrl: '',
        propVal: '',
        isMallShow: this.isSwitchShow
      }).then((res) => {
        if (res.data.success) {
          this.$message.success('添加属性成功')
        } else {
        }
      })
    },
    //  获取合成尺寸信息
    getComposeTypeSize () {
      sizeList().then((res) => {
        if (res.data.success) {
          let newList = []
          res.data.data.forEach((item) => {
            if (item.composeTypeId === parseInt(this.content)) {
              newList.push(item)
              newList.forEach((item2) => {
                item2.bleed = {
                  bleedName: '',
                  bleedOut: '',
                  bleedIn: '',
                  bleedTop: '',
                  bleedBottom: ''
                }
                this.getBleed(item2.bleedId).then(res => {
                  item2.bleed = res
                })
                item2.composeName = this.submitType
              })
            }
          })
          this.technologyList = newList
        } else {
        }
      })
    },
    async getBleed (id) {
      let post = () => {
        return new Promise(resolve => {
          bleedDetail(id).then((res) => {
            if (res.data.success) {
              resolve(res.data.data)
            }
          })
        })
      }
      let result = await post()
      return result
    },
    selectComposeSize (row) {
      this.selectComposeSizeList.forEach((item, index) => {
        if (item.composeName === row.composeName) {
          this.selectComposeSizeList.splice(index, 1)
        }
      })
      this.selectComposeSizeList.push(row)
      this.$emit('selectComposeType', this.selectComposeSizeList)
      this.$message.success('关联尺寸成功')
      this.hide()
    }
  }
}
</script>
<style lang="less" scoped>
@import "styles";
</style>
